import { render, staticRenderFns } from "./callthepolice.vue?vue&type=template&id=e77ca8ee"
import script from "./callthepolice.vue?vue&type=script&lang=js"
export * from "./callthepolice.vue?vue&type=script&lang=js"
import style0 from "./callthepolice.vue?vue&type=style&index=0&id=e77ca8ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports